export const REGISTRATION_BUTTON_CLICKED = 'REGISTRATION_BUTTON_CLICKED'

export const registrationButtonClicked = () => ({type: REGISTRATION_BUTTON_CLICKED})
